import isProduction from './isProduction';
import getQueryParams from './getQueryParams';
import isE2 from './isE2';

// aipdev = feature flag
const useProductionFeatureFlag = () =>
  ((isProduction() || isE2()) && getQueryParams().aipdev === 'true') || __DEV__;

export default useProductionFeatureFlag;
